import { render } from "./PdfDispatch.vue?vue&type=template&id=0576331a&scoped=true"
import script from "./PdfDispatch.vue?vue&type=script&lang=js"
export * from "./PdfDispatch.vue?vue&type=script&lang=js"

import "./PdfDispatch.vue?vue&type=style&index=0&id=0576331a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0576331a"]])

export default __exports__